export default {
  'Custom': 'Custom',
  'Original': 'Original',
}